/// <amd-module name="VSSUI/Utilities/ChildrenUtils" />
import * as React from "react";

/** @deprecated */
export interface ReactChild<T> {
    index: number;
    item: T;
}

/**
 * Gets the children of the specified type (includes child index as well).
 *
 * @param props Container props including children.
 * @param type Type of the children.
 */
/** @deprecated */
export function childrenOfType<T>(children: React.ReactNode, type: { new (props?: any): T }): ReactChild<T>[] {
    let found: ReactChild<T>[] = [];
    React.Children.map(children || [], (item: any, index: number) => {
        if (typeof item === "object" && item.type === type) {
            found.push({ index, item });
        }
    });

    return found;
}
